import React ,{useState}from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Hero from "../../components/Careers/Hero/Hero";
import Box from "../../components/Careers/box/Box";
import UpButton from '../../components/UpButton';
//============================================
import styles from "./Careers.module.scss";
import { Helmet } from "react-helmet";
import SubServPart from '../../components/SubServPart' ;
import {products_last_part} from '../../Data/product_new' ;
//== 
import  { useContext ,useEffect } from 'react';
import { LanguageContext } from '../../context/LanguageContext';
//==

const Careers = ({scroll , lang}) => {
  const [job,setJob] = useState('Sales / Marketing') ;
  
  //---
  const { toggleLanguage } = useContext(LanguageContext);
  useEffect(() => {
    toggleLanguage(lang)
  },);
  //--- 
  return (
    <div>
      <Helmet>
        <title>Millensys - Careers</title>
      </Helmet>
      <UpButton scroll={scroll} />
      <div>
        <Header />
        <Hero />
        <div className={styles["certification_container"]}>
          <div className={styles["section__container"]}>
            <p className={styles["section__subheader"]}>Become a MILLENSYS <br />team member</p>
            <p className={styles["__strong"]}>
              MILLENSYS is contentiously improving and expanding its product line
              by introducing innovative ideas to complete its product line for both business and healthcare market.
            </p>
            <p className={styles["section__header"]}>
              In order to ensure continuous and stable growth, we are always looking for highly talented staff to 
              join our company. we are in a need now for the following positions:
            </p>
          </div>
          <div className={styles.certification}>
            <button className={`${styles.product___btn} ${styles.box}`} onClick={()=>{setJob('Sales / Marketing')}}>Sales / Marketing</button>
            <button className={`${styles.product___btn} ${styles.box}`}onClick={()=>{setJob('Projects / Implementation')}}>Projects / Implementation</button>
            <button className={`${styles.product___btn} ${styles.box}`}onClick={()=>{setJob('Software Development')}}>Software Development</button>
            <button className={`${styles.product___btn} ${styles.box}`}onClick={()=>{setJob('Technical Support')}}>Technical Support</button>
          </div>
        </div>
        <Box job={job} />
        <SubServPart products={products_last_part} title={'Value For Everyone'} overview={'Create and deliver a value for all stakeholders'}/>
        <Footer />
      </div>
    </div>
  );
};

export default Careers;
